<template>
  <div class="wallet_flow">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="tdc_name" align="center" label="城市仓">
        </el-table-column>
        <el-table-column prop="tdc_id" align="center" label="城市仓ID">
        </el-table-column>
        <el-table-column prop="revenue_type_txt" align="center" label="收支">
        </el-table-column>
        <el-table-column prop="amount" align="center" label="金额">
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="时间">
        </el-table-column>
        <el-table-column prop="flow_type_txt" align="center" label="类型">
        </el-table-column>
        <el-table-column prop="desc" align="center" label="描述">
        </el-table-column>
        <el-table-column prop="wallet_amount" align="center" label="账户余额">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注">
            <template slot-scope="scope">
              <div>
                <span v-for="(item, index) in scope.row.remark" :key="item">{{ item }}<template v-if="index !== scope.row.remark.length - 1">,</template></span>
              </div>
            </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
           
            <el-button
              type="text"
              v-if="scope.row.type==10||scope.row.type==21"
              @click="seelink(scope.row)"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.type==20||scope.row.type==12||scope.row.type==24"
              @click="downloadinfo(scope.row)"
              >下载明细</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.deduction_pic"
              @click="seeimg(scope.row)"
              >查看图片</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
        <!-- 文件预览 start -->
    <c-preview-file
      v-model="dialogVisible"
      :fileList="fileList"
      :fileIndex="previewIndex"
      :fileType="fileType"
    ></c-preview-file>
    <!-- 文件预览 end -->
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import CPreviewFile from "@/components/common/CPreviewFile/index.vue";
export default {
  name: "wallet_flow",
  components: {
    Filtersearch,
    CPreviewFile
  },
    computed: {
    /**
     * 获取文件类型
     */
    getFileType() {
      return (file) => {
        const extIndex = file.url.lastIndexOf(".");
        const fileType = file.url.slice(extIndex + 1).toLocaleLowerCase();
        return fileType;
      };
    },
  },
  data() {
    // 近一周时间（格式：yyyy-MM-dd HH:mm:ss）
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    const fmt = (d) => {
      const pad = (n) => (n < 10 ? "0" + n : n);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate())
      );
    };
    const defaultStart = fmt(start);
    const defaultEnd = fmt(end);

    return {
        dialogVisible: false,
        fileList: [],
        previewIndex:0,
        fileType:'',
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      centerDialogVisible: false,
      Filterdata: [],
      itemobj: "",

      from: {
        start:[defaultStart,defaultEnd],
        time_start: defaultStart, //	T文本	是	近一周开始时间
        time_end: defaultEnd, //	T文本	是	近一周结束时间
        page: 1, //	T文本	是
        pageSize:50, //	T文本	是
        flow_type: "", //	T文本	否	23
        revenue_type: "", //	T文本	否1 收入   -1 支出
      },
      from1: "",
      Selectionlist: [],
      Filtersearchlist: [
          {
          type: "daterange",
          name: "时间",
          clearable: false,
          model: "start",
          startmodel: "time_start",
          endmodel: "time_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
    
        {
          type: "select",
          name: "类型",
          clearable: true,
          model: "flow_type",
          placeholder: "请选类型",
          label: "name",
          value: "val",
          selectoption: [
          ],
           selectoptionname: "flow_type_list",
        },
        {
          type: "select",
          name: "收支",
          clearable: true,
          model: "revenue_type",
          placeholder: "请选收支",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "收入",
              value: 1,
            },
            {
              label: "支出",
              value: 2,
            },
         
          ],
        },
       
      ],
    };
  },
  created() {
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
  },
  watch: {},
  methods: {
    seelink(e) {
      console.log(e,'111111111111111111');
     if (e.auth_alert) {
        this.$alert(e.auth_alert, "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
     if(e.type==10){
        this.$router.push({
          path: "/tdc-manage/account/details",
          query: {
            jump_time: e.jump_time,
          },
        });
     }
     if(e.type==21){
        this.$router.push({
          path: "/self-procurement-list",
          query: {
            jump_time: e.jump_time,
          },
        });
     }
    },
    downloadinfo(e) {
     if (e.auth_alert) {
        this.$alert(e.auth_alert, "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
     if(e.type==20){
const query = {
          jump_time:e.jump_time,
          token: sessionStorage.getItem("token"),
        };
     

        this.$api.biexport.as_list_export(query).then((res) => {
          this.goExportCenter();
        });
     }else if(e.type==12){
const query = {
          jump_time:e.jump_time,
          token: sessionStorage.getItem("token"),
        };
     

        this.$api.biexport.promotion_list_export(query).then((res) => {
          this.goExportCenter();
        });
     }else if(e.type==24){
const query = {
          jump_id:e.jump_id,
          token: sessionStorage.getItem("token"),
        };
     

        this.$api.biexport.coupon_list_export(query).then((res) => {
          this.goExportCenter();
        });
     }
    },
    seeimg(e) {
     if (e.auth_alert) {
        this.$alert(e.auth_alert, "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
      let tmpImageList = [];
    
        tmpImageList.push({
          label: "图片",
          url: e.deduction_pic,
        });
    
      this.fileList = tmpImageList;
      this.dialogVisible = true;
      this.fileType = this.getFileType(this.fileList[0]);
    },


   

    /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.from,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;

        this.$api.biexport.flowlistexport(query).then((res) => {
          this.goExportCenter();
        });
      } catch (err) {
        this.$message.error("导出失败了");

      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    getsearch() {
      this.$api.tdc.wallet_flow_filter_list().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data.list;
        this.Filtersearchlist.forEach((el) => {
          if (
            (el.type == "select") &&
            el.selectoptionname=='flow_type_list'
          ) {
     
            el.selectoption = this.Filterdata;
          }
        });
      });
    },
    Refresh() {
      this.Filtersearchlist.forEach((el) => {
        if (
           (el.type == "select") &&
            el.selectoptionname=='flow_type_list'
        ) {
          el.selectoption = this.Filterdata;
        }
      });
      Object.assign(this.$data.from, this.$options.data().from);
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    search(e) {
      this.from.page = 1;
      this.currentPage = 1;
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.tdc.wallet_flow_list(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.wallet_flow {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .contents {
    padding: 0 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
